import SlickSlider from '../SlickSlider';

/**
 * Component: Product Video
 */

export default class ProductVideo {

    constructor() {
        this.selectors = {
            root: '.product-overview',
            slider: '[data-product-media-slider]',
            thumbnail: '[data-product-thumbnail-slider]'
        };
        this.$rootElement = $(this.selectors.root);
        this.$slider = this.$rootElement.find(this.selectors.slider);
        this.$thumbnailSlider = this.$rootElement.find(this.selectors.thumbnail);
        this.thumbnailSliderLength = $('.product-overview__gallery-slide.thumbnail-slide').length;
        this.init();
    }

    init() {
        this.createThumbnailSlider();
        this.createSlider();
    }

    createSlider() {
        const config = {
            asNavFor: this.$thumbnailSlider,
            centerMode: false,
            variableWidth: false,
            infinite: true,
            draggable: false,
            arrows: true,
            dots: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            rows: 0,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        };
        return new SlickSlider(this.$slider, config);
    }

    createThumbnailSlider() {
        const config = {
            asNavFor: this.$slider,
            centerMode: false,
            slidesToShow: this.thumbnailSliderLength,
            infinite: true,
            vertical: true,
            draggable: false,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            slidesToScroll: 1,
            rows: 0
        };
        return new SlickSlider(this.$thumbnailSlider, config);
    }
}
